import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ActionSheetController, Platform, ViewController } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';

@IonicPage()
@Component({
  selector: 'page-select-hire-machine',
  templateUrl: 'select-hire-machine.html',
})
export class SelectHireMachinePage {
  show: boolean = false;
  vehicleList: any = [];
  vehicleName: any = "";
  vehicleDescription: any = "";
  selectOptions: any;
  constructor(public viewCtrl: ViewController,
    private api: CrudProvider,
    private utiltiy: UtiltiyProvider,
    public platform: Platform,
    public actionSheetController: ActionSheetController,) {
    this.selectOptions = {
      mode: 'ios'
    };
    if (this.viewCtrl.data.isKlmr) {
      this.show = true;
    }

    if(this.viewCtrl.data.data){
      let params = this.viewCtrl.data.data;
      this.vehicleName = params.vehicleName;
      this.vehicleDescription = params.vehicleDescription;
      console.log("params",params)
    }
  }

  ionViewDidLoad() {
    this.getVehicleList();
  }

  closeModal(){
    this.viewCtrl.dismiss()
  }

  onSubmit(){
    let data = {
      "vehicleName": this.vehicleName,
      "vehicleDescription":  this.vehicleDescription
    }
    this.viewCtrl.dismiss(data)
  }

  async getVehicleList() {
    this.utiltiy.startLoading();
    let baseUrl = this.show ? "/prestart/fuel/fuel/Vehicle_Type" : "/tansix_prestart/fuel/fuel/Vehicle_Type";
    let formData: FormData = new FormData();
    formData.append("method_name", "get_vehicle_type_list");
    this.api.post(baseUrl, false, formData)
      .then((result: any) => {
        console.log("result", result)
        this.utiltiy.stopLoading();
        if (result.status) {
          this.vehicleList = result.result;
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        [];
      })
  }

}



// WEBPACK FOOTER //
// ./src/pages/select-hire-machine/select-hire-machine.ts